import BaseApi from "./base";

export default class User extends BaseApi {
  baseName = "user";

  registerPassword = options => {
    return this.create({ ...options, endpoint: "register/password" });
  };
}
